import React, { useState, useEffect, useRef  } from 'react'



const Index = ({url,success,fail,loader}) => {


    const [status, setStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    const [imageURL, setImageURL] = useState(null)

    const checkImage = path =>     
    new Promise(resolve => {

    const img = new Image();
    img.onload = () => resolve({path, status: 'ok'});
    img.onerror = () => resolve({path, status: 'error'});

    img.src = path;
    });

    
    useEffect(() => {	
      setLoading(true)
      checkImage(url).then(
            e=>{             
                if(e.status === 'ok'){
                  setImageURL(url)  
                  setStatus(true)
                  setLoading(false)              
                }else{
                  setImageURL(url)            
                  setLoading(false)
                }
            }
        )
    }, [])

    useEffect(() => {	
      if(imageURL !== url && url){
        setLoading(true)
        checkImage(url).then(
          e=>{             
            if(e.status === 'ok'){
              setImageURL(url)  
              setStatus(true)
              setLoading(false)              
            }else{
              setImageURL(url)            
              setLoading(false)
            }
          }
        )

      }
    }, [url])

    
   

    const condtions =() =>{
      if(status && !loading){        
        return (<>{success}</>);
      }else if(loading && loader){
          return (<>{loader}</>);
      }else{
        return (<>{fail}</>);
      }
    }

    return(condtions())


  
}


export default Index;